import React, { useContext, useCallback } from "react";
import * as Sentry from "@sentry/react";
import { UI } from "@wwimmo/ui";
import { submitUserFeedback } from "src/utils/Feedback";
import { RootStoreContext } from "src/stores/RootStore";
import { observer } from "mobx-react";

export interface ErrorProps {
    message?: string;
    networkError?: Error & any;
    componentStack?: string | null;
    resetError?: () => void;
    error?: Error | null;
}

const ErrorBase = (props: ErrorProps) => {
    const { navStore, easyContactStore } = useContext(RootStoreContext);

    const handleSubmitFeedback = useCallback(() => {
        submitUserFeedback(
            easyContactStore.notification.contactperson?.email,
            `${easyContactStore.notification.contactperson?.name1} ${easyContactStore.notification.contactperson?.name2}`
        );
    }, [
        easyContactStore.notification.contactperson?.email,
        easyContactStore.notification.contactperson?.name1,
        easyContactStore.notification.contactperson?.name2
    ]);

    return (
        <UI.Container className="pt-4">
            <UI.Row>
                <UI.Col className="text-center mt-4 pt-4">
                    <UI.ErrorCard
                        onSubmitFeedback={handleSubmitFeedback}
                        {...props}
                        showBackButton={navStore.getPreviousPage.length > 0}
                    />
                </UI.Col>
            </UI.Row>
        </UI.Container>
    );
};

export const Error = Sentry.withProfiler(observer(ErrorBase));
